import { styled } from '@mui/material/styles';

import useResponsive from '../../hooks/useResponsive';

const StyledSection = styled('div')(({ theme }) => ({
  position: 'relative',
  borderTopLeftRadius: '0%',
  borderBottomLeftRadius: '25%',
  height: '100hv',
  width: '50%',
  backgroundImage: `url('/assets/landing/headChurch.jpg')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  // boxShadow: `${theme.palette.mode === 'dark' ? '' : '0 0 15px  rgba(0, 0, 0, 0.5)'}`,
  animation: 'cycle-shadow 2s infinite',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.25)' : 'transparent',
    borderTopLeftRadius: '0%',
    borderBottomLeftRadius: '25%',
  },
  '@keyframes cycle-shadow': {
    '0%': {
      boxShadow: theme.palette.mode === 'dark' ? '' : '0 0 5px #366538', // dark green
    },
    '50%': {
      boxShadow: theme.palette.mode === 'dark' ? '' : '0 0 2px #918a30', // dark yellow
    },
    '100%': {
      boxShadow: theme.palette.mode === 'dark' ? '' : '0 0 5px #79343d', // dark red
    },
  },
}));

export default function LeftHome() {
  const mdUp = useResponsive('up', 'lg');

  return <>{mdUp && <StyledSection />}</>;
}
